package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class Sender(
    val id: String,
    val store: String,
    val name: String,
    var email: String = "",
    var reply: String = "",
    var confirm: Boolean = false
)

@Serializable
data class SenderUpdateRequest(
    val name: String,
    val store: String,
    val email: String,
    val reply: String,
)